import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";

import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import Api from "../../../../constants/Api";
import MenuConfig from "../../../../constants/MenuConfig";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import InputText from "../../../components/Forms/Element/InputText";
import DreGroupSelect from "../../../components/Custom/CashFlow/Category/DreGroupSelect";
import { SearchOperation } from "../../../../utils/ApiUtils";

const CategoryList = () => {

    const { t } = useTranslation();
    const [nameFilter, setNameFilter] = useState('');
    const [dreGroupFilter, setDreGroupFilter] = useState(null);
    const [filters, setFilters] = useState([]);

    const handleSearch = () => {
        const activeFilters = [];

        if (nameFilter && nameFilter.trim()) {
            activeFilters.push({
                field: "name",
                value: nameFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }

        if (dreGroupFilter) {
            activeFilters.push({
                field: "dreGroup",
                value: dreGroupFilter.value,
                operation: SearchOperation.EQUAL
            });
        }

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setNameFilter('');
        setDreGroupFilter(null);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t('cash_flow.categories')} motherMenu={t('cash_flow.label')} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                <Row className="g-2 align-items-end">
                    <Col lg={5} md={6}>
                        <FormLabel>{t('name')}</FormLabel>
                        <InputText
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                            placeholder={t('category_name_placeholder')}
                        />
                    </Col>
                    <Col lg={5} md={6}>
                        <FormLabel>{t('dre_group')}</FormLabel>
                        <DreGroupSelect
                            value={dreGroupFilter}
                            onChange={(value) => setDreGroupFilter(value)}
                        />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={t('cash_flow.categories')}
                motherMenu={t('cash_flow.label')}
                path={Api.cash_flow.category}
                route={MenuConfig.cash_flow.categories.route}
                columns={Columns}
                filters={filters}
            />
        </>
    );
}

export default CategoryList;